module.exports = __webpack_public_path__ + "static/img/menu-cg-light.c081603.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/menu-cg-light.png
// module id = jOb1
// module chunks = 2